// src/hooks/useReceiverDashboardStats.js
import { useEffect, useMemo, useState } from "react";
import { useScheduleData } from "./useScheduleData";

function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function useReceiverDashboardStats(user) {
  const { rows, loading, error } = useScheduleData();

  // "last login" timestamp for "since login" metric
  const [lastLoginAt, setLastLoginAt] = useState(null);

  useEffect(() => {
    const key = "receiver:lastLoginAt";
    const existing = localStorage.getItem(key);
    if (existing) {
      setLastLoginAt(existing);
      return;
    }

    const now = new Date().toISOString();
    localStorage.setItem(key, now);
    setLastLoginAt(now);
  }, [user]);

  const stats = useMemo(() => {
    const now = new Date();
    const cutoff30d = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    const lastLoginDate = parseDate(lastLoginAt);

    let delivered = 0;
    let scheduled = 0;
    let lastDelivery = null;
    let received30d = 0;
    let newSinceLogin = 0;

    for (const r of rows) {
      if (r.status === "delivered") {
        delivered += 1;
        const d = parseDate(r.dateReceived);
        if (!d) continue;
        if (!lastDelivery || d > lastDelivery) lastDelivery = d;
        if (d >= cutoff30d) received30d += 1;
        if (lastLoginDate && d > lastLoginDate) newSinceLogin += 1;
      } else if (r.status === "scheduled") {
        scheduled += 1;
      }
    }

    return {
      totalReceived: delivered,
      pendingPickups: scheduled,
      received30d,
      lastDeliveryTime: lastDelivery ? lastDelivery.toISOString() : null,
      newDeliveriesSinceLogin: newSinceLogin,
    };
  }, [rows, lastLoginAt]);

  return {
    loading,
    error: error || null,
    stats,
  };
}
